'use client'

import { useEffect, useRef } from 'react'
import { trackEvent } from '@/lib/analytics'
import { normalizeReferralCode } from '@/lib/referral/config'
import { storeReferralCode } from '@/lib/referral/client-storage'

const UTM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign'] as const

export function referralCodeFromResultSearch(search: string): string | null {
  try {
    const params = new URLSearchParams(search)
    return normalizeReferralCode(params.get('ref'))
  } catch {
    return null
  }
}

export function resultUtmFromSearch(search: string): Record<string, string> {
  try {
    const params = new URLSearchParams(search)
    const out: Record<string, string> = {}
    for (const key of UTM_KEYS) {
      const value = params.get(key)
      if (value) out[key] = value
    }
    return out
  } catch {
    return {}
  }
}

export function ResultAttributionTracker({
  resultId,
  resultType,
}: {
  resultId: string
  resultType: 'identify' | 'diagnosis'
}) {
  const fired = useRef(false)

  useEffect(() => {
    if (fired.current) return
    fired.current = true

    const search = window.location.search
    const code = referralCodeFromResultSearch(search)
    if (code) storeReferralCode(code)

    trackEvent('result_landing_viewed', {
      result_id: resultId,
      result_type: resultType,
      has_referral: Boolean(code),
      ...resultUtmFromSearch(search),
    })
  }, [resultId, resultType])

  return null
}
